((app, ng) => {
    app.component("flows", {
        templateUrl: "/App/States/DataFlow/Flows/flows.html",
        controller: flowsCtrl,
        bindings: {
            data: "<",
            onReload: "&"
        }
    });

    flowsCtrl.$inject = ["$mdDialog"];
    function flowsCtrl($mdDialog) {
        var $ctrl = this;
        $ctrl.ui = {};

        $ctrl.openUpdateFrequency = (event, track) => {
            $mdDialog.show({
                locals: {
                    track: track
                },
                controller: "frequencyCtrl",
                templateUrl: "/App/States/Modals/Frequency/frequency.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: false
            })
            .then((updates) => {
                if (updates) {
                    $ctrl.onReload();
                }
            });
        };
    }

})(window.app, window.angular);